import * as React from 'react'
import { StyledCheckbox } from './CheckBox.style'
import colors, { Color } from '../../theme/colors'
import analyticsAttributes, { Props as AnalyticsProps } from '../../../util/analytics-data-attributes/analyticsAttributes'

type Props = {
  id: string
  checked: boolean
  label: string
  onClick: (event: React.MouseEvent<HTMLElement>) => void
  disabled?: boolean
  className?: string
  color?: Color
  analytics?: AnalyticsProps
}

/**
 * Checkbox element
 * @param {object} props Component props
 * @param {string} props.id Checkbox id
 * @param {boolean} props.checked Checked state
 * @param {boolean} props.label Label text
 * @param {boolean} props.disabled Disabled state
 * @param {string} props.color Color of tick symbol
 */

const CheckBox = ({ id, checked, disabled, onClick, label, className, color, analytics }: Props) => (
  <StyledCheckbox disabled={disabled} color={color} className={className}>
    <input {...analyticsAttributes(analytics)} onClick={onClick} type="checkbox" id={id} checked={checked} disabled={disabled} readOnly />
    <label {...analyticsAttributes(analytics)} htmlFor={id}>{label}</label>
  </StyledCheckbox>
)

export default CheckBox

CheckBox.defaultProps = {
  disabled: false,
  color: colors.Primary.GreyText,
}
